import React, { createContext, useContext, useEffect } from 'react';
import { useState } from "react";
import { useFile } from 'components/useFile';
import { Urls } from 'components/Data';
import { LoadingPage } from 'components/LoadingPage';

type CourseDataProps = {
  urls: Urls
  semester: string
  children: React.ReactNode
}

const CourseDataContext = createContext<any>({});
export const useCourseData = () => useContext(CourseDataContext);
export function CourseDataProvider({ urls, semester, children }: CourseDataProps) {
  const [courses, loadingCourses] = useFile(`${urls.dataroot}static/courses-${semester}.json`, (r) => r.json());
  const value = { courses };

  if (loadingCourses) {
    return <LoadingPage />;
  }

  return (
    <CourseDataContext.Provider value={value} >
      { children }
    </CourseDataContext.Provider>
  );
}
